import { scroller } from 'react-scroll';

const scrollToAnchor = ({ anchor, offset, duration, delay }) => {
  const options = {
    offset: offset ?? 0,
    duration: duration ?? 100,
    delay: delay ?? 0,
    smooth: 'easeInOutQuint',
    ignoreCancelEvents: true
  };
  scroller.scrollTo(anchor, options);
};

export default scrollToAnchor;
